var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiFloatingMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 2C24.9142 2 25.25 2.33579 25.25 2.75V4.75H27.25C27.6642 4.75 28 5.08579 28 5.5C28 5.91421 27.6642 6.25 27.25 6.25H25.25V8.25C25.25 8.66421 24.9142 9 24.5 9C24.0858 9 23.75 8.66421 23.75 8.25V6.25H21.75C21.3358 6.25 21 5.91421 21 5.5C21 5.08579 21.3358 4.75 21.75 4.75H23.75V2.75C23.75 2.33579 24.0858 2 24.5 2ZM12.5699 4.38558C12.8281 4.20481 13.1719 4.20481 13.4301 4.38558L22.4301 10.6856C22.6306 10.8259 22.75 11.0553 22.75 11.3V21.2C22.75 21.9033 22.4389 22.5596 21.9159 23.0303C21.3956 23.4985 20.7053 23.75 20 23.75H13H6C5.29467 23.75 4.60438 23.4985 4.08406 23.0303C3.56114 22.5596 3.25 21.9033 3.25 21.2V11.3C3.25 11.0553 3.36941 10.8259 3.5699 10.6856L12.5699 4.38558ZM13.75 18V22.25H20C20.3555 22.25 20.6827 22.1222 20.9125 21.9153C21.1397 21.7108 21.25 21.4514 21.25 21.2V11.6905L13 5.91549L4.75 11.6905V21.2C4.75 21.4514 4.86029 21.7108 5.08751 21.9153C5.31734 22.1222 5.64447 22.25 6 22.25H12.25V18C12.25 17.5858 12.5858 17.25 13 17.25C13.4142 17.25 13.75 17.5858 13.75 18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiFloatingMain);
export default __webpack_public_path__ + "static/media/wikiFloating-main.c162ed36403119b595417879ea473269.svg";
export { ForwardRef as ReactComponent };